import { Tab, Tabs, Box } from '../../Material/index'
import colors from 'colors'
import { FieldErrors } from 'react-hook-form'
import React from 'react'

type TabProps = {
  tabObject: {
    label: string
    name: string
  }[]
  selectedTab: number
  handleTabChange: (event: React.SyntheticEvent, newValue: number) => void
  errors?: FieldErrors
}

export const CustomMaterialTab = ({
  tabObject,
  selectedTab,
  handleTabChange,
  errors
}: TabProps) => {
  const tabs = tabObject.map((tab, index) => (
    <Tab
      key={index}
      title={tab.label || ''}
      label={<Box>{tab.label}</Box>}
      sx={{
        textTransform: 'none',
        fontFamily: 'BB-Font-Bold',
        color: tab?.name && errors && errors[tab?.name] && 'red',

        '& .MuiTabs-root': {
          maxWidth: '390px'
        }
      }}
    />
  ))

  const errorField = errors && errors[tabObject[selectedTab]?.name]
  return (
    <Box
      className="w-full flex justify-center"
      sx={{
        borderBottom: '1px solid #E6E6E6'
      }}
    >
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
        sx={{
          width: '100%',
          px: 1,
          maxWidth: '390px',
          '& .MuiTabs-flexContainer': {
            justifyContent: 'space-around'
          },
          '& .MuiTab-root': {
            maxWidth: 87.5
          },
          '& .MuiTabs-indicator': {
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: 'transparent',
            height: '3px'
          },
          '& .MuiTabs-indicatorSpan': {
            maxWidth: 40,
            width: '100%',
            backgroundColor: errorField ? 'red' : colors['blue-bb'],
            borderRadius: '100px 100px 0 0'
          }
        }}
      >
        {tabs}
      </Tabs>
    </Box>
  )
}
